import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field, ErrorMessage } from "formik";
import React, { useState } from "react";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table, Modal } from "react-bootstrap";
import ShowAlert from "../../alert";
import { allowAlphabetAndSpacesOnly, AlphaNumericValidation, generatePDF, GetDetails, LabelHeader, ModuleHeader, showNotification, } from "../../utils/commonFunctions";
import { MdOutlinePictureAsPdf, MdPersonAddAlt1 } from "react-icons/md";
import { store } from "../../../App";
import { MdPersonRemoveAlt1 } from "react-icons/md";
import { FaUserEdit } from "react-icons/fa";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as Yup from "yup";

const SubHeadMaster = () => {
  const [headOptions, setHeadOptions] = useState([]);
  const [subHeadsData, setSubHeadData] = useState([]); const [isSubmitted, setIsSubmitted] = useState(false); const [openAddPopUp, setopenAddPopUp] = useState(false); const [openEditPopUp, setopenEditPopUp] = useState(false);


  React.useEffect(() => {
    HousingService.HeadNames().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.headid}> {item.heads} </option>
            );
          }
        });
        setHeadOptions(options);
      }
    });
  }, []);

  const validationSchema = Yup.object().shape({
    headnames: Yup.string().required("Head ID is required"),
  });

  const formik2 = useFormik({
    initialValues: {
      headnames: "",
      editsheadid: "",
      editssubseqheadid: "",
      editsubheadname: "",
      editsubheadid: "",
      addheadid: "", addsubheadid: "",
      addsubheadname: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      store.dispatch({ type: "SHOW_SPINNER" });
      loadSubHeadData(values.headnames);
    },
  });

  const loadSubHeadData = (headid) => {
    const params = { headid };
    HousingService.GetSubHeadsData(params).then((res) => {
      if (res?.data?.length > 0) {
        setSubHeadData(res.data);
      } else {
        setSubHeadData([]);
      }
    }).catch(() => {
      ShowAlert("Failed to load SubHead data", "error");
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
      setIsSubmitted(true);
    });
  };
  const addClick = () => {
    empty();
    setopenAddPopUp(true);
  }

  const editClick = (headid, subheadseqid, subheadid, subheadname) => {
    setopenEditPopUp(true);
    formik2.setFieldValue("editsheadid", headid); formik2.setFieldValue("editssubseqheadid", subheadseqid);
    formik2.setFieldValue("editsubheadid", subheadid); formik2.setFieldValue("editsubheadname", subheadname);
  }

  const deleteClick = (headid, subheadseqid,subheadid) => {
    Swal.fire({
      title: `<span style="font-size:16px;">Delete SubHead Id: ${subheadid} ?</span>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        store.dispatch({ type: "SHOW_SPINNER" });
        let param3 = [{ headid: headid, subheadseqid: subheadseqid }];
        HousingService.rowdel(param3)
          .then((response) => {
            if (response?.data?.SCODE === "01") {
              showNotification("success", response?.data?.SDESC);
              loadSubHeadData(formik2.values.headnames);
            }
          })
          .catch((error) => {
            ShowAlert("Some error occurred", "error");
            console.log(error);
          })
          .finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
          });
      }
    });
  };


  const submitsubheadEditAction = () => {
    if (!formik2.values.editsubheadname) {
      ShowAlert("Please fill the required fields: SubHead Name", "warning");
      return;
    }

    store.dispatch({ type: "SHOW_SPINNER" });

    const params = { subheadname: formik2.values.editsubheadname, subheadid: formik2.values.editsubheadid, subheadseqid: formik2.values.editssubseqheadid, };
    HousingService.rowUpdate(params).then((res) => {
      const data = res?.data?.[0];
      if (data?.Status === 1) {
        ShowAlert(data?.responseMsg, "success");
        loadSubHeadData(formik2.values.headnames);
      } else {
        ShowAlert(data?.responseMsg || "Having some Error", "error");
      }
    }).catch(() => {
      ShowAlert("Some error occurred", "error");
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
      setopenEditPopUp(false);
    });
  };


  const empty = () => {
    formik2.setFieldValue("addsubheadid", "");
    formik2.setFieldValue("addsubheadname", "");
  }
  const submitsubheadAddAction = () => {
    if (!formik2.values.addsubheadid || !formik2.values.addsubheadname) {
      let missingFieldsaddSubhead = [];
      if (!formik2.values.addsubheadid) missingFieldsaddSubhead.push("SubHead ID");
      if (!formik2.values.addsubheadname) missingFieldsaddSubhead.push("SubHead Name");
      ShowAlert(`Please fill the required fields: ${missingFieldsaddSubhead.join(", ")}`, "warning");
      return;
    }
    store.dispatch({ type: "SHOW_SPINNER" });
    const params = { headid: formik2.values.addheadid, subheadid: formik2.values.addsubheadid.trimEnd(), subheadname: formik2.values.addsubheadname };
    console.log("params:",params)
    HousingService.rowinsert(params).then((res) => {
      const data = res?.data?.[0];
      if (data?.Status === 1) {
        ShowAlert(data?.responseMsg, "success");
        empty();
        loadSubHeadData(formik2.values.headnames);
      } else {
        ShowAlert(data?.responseMsg, "error");
        setopenAddPopUp(false);
      }
    }).catch(() => {
      ShowAlert("Some error occurred", "error");
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
      setopenAddPopUp(false);
    });
  };

  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="SubHeads Master" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }} >
        <FormikProvider value={formik2}>
          <Form onSubmit={formik2.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                <LabelHeader title="HeadNames" />
                <Field component="select" name="headnames" className={formik2.touched.headnames && formik2.errors.headnames ? "form-control is-invalid" : "form-control"} onChange={(e) => formik2.handleChange(e)} >
                  <option value="">Select</option>
                  {headOptions}
                </Field>
                <ErrorMessage name="headnames" component={"div"} className="text-error" />
              </OFMSUI.Col>
              <GetDetails />
            </OFMSUI.Row>
            {isSubmitted && (<>
              <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                  <button type="button" className="btn btn-danger btn-sm" onClick={() => generatePDF("my-tablesubheadsmaster", "SubHeads List", "SubHeadMaster.pdf", 3)} style={{ float: "right", fontSize: "12px" }} > Download PDF <MdOutlinePictureAsPdf /> </button>
                </OFMSUI.Col>
              </OFMSUI.Row>
              <div style={{ overflow: "auto", height: "500px" }}>
                <Table striped bordered hover id="my-tablesubheadsmaster">
                  <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                    <tr className="table_countshead">
                      <th className="text-center">S No.</th> <th>SubHead Id</th> <th>SubHead Name</th> <th className="text-center">Edit</th> <th className="text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subHeadsData && subHeadsData.length > 0 ? (
                      subHeadsData.map((itemsubhead, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td>{itemsubhead.subheadid}</td>
                          <td>{itemsubhead.subheadname}-{itemsubhead.subheadseqid}</td>
                          <td className="text-center" onClick={() => { editClick(itemsubhead.headid, itemsubhead.subheadseqid, itemsubhead.subheadid, itemsubhead.subheadname); }}>
                            <button type="button" className="btn btn-dark btn-sm">
                              <FaUserEdit style={{ fontSize: "20px", color: "orange", background: "none" }} />
                            </button>
                          </td>
                          <td className="text-center" onClick={() => { deleteClick(itemsubhead.headid, itemsubhead.subheadseqid,itemsubhead.subheadid); }}>
                            <MdPersonRemoveAlt1 style={{ fontSize: "30px", color: "red" }} />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>

                </Table>
              </div>
              <center> <button className="btn btn-primary btn-sm" type="button"
                onClick={() => {
                  formik2.setFieldValue("addheadid", formik2.values.headnames);
                  addClick();
                }}
              > Add SubHead<MdPersonAddAlt1 style={{ fontSize: "30px" }} /></button> </center>
            </>)}
            <Modal fade={false} size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={openEditPopUp} >
              <Modal.Header > <Modal.Title >Edit Sub Head Details</Modal.Title> </Modal.Header>
              <Modal.Body>
                <Form onSubmit={formik2.handleSubmit}>
                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold"> <tr> <th>SubHead ID</th> <th>SubHead Name</th> </tr> </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="editsubheadid"
                            onChange={formik2.handleChange}
                            className={formik2.touched.editsubheadid && formik2.errors.editsubheadid ? "form-control is-invalid" : "form-control"}
                            disabled
                          ></Field>
                        </td>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="editsubheadname"
                            onChange={formik2.handleChange}
                            className={formik2.touched.editsubheadname && formik2.errors.editsubheadname ? "form-control is-invalid" : "form-control"}
                          ></Field>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <OFMSUI.Row>
                    <center> <button type="button" style={{ marginRight: "1rem" }} size="sm" className="btn btn-success" onClick={() => { submitsubheadEditAction(); }} > Save </button> <button type="button" style={{ marginRight: "1rem" }} size="sm" onClick={() => { setopenEditPopUp(false); }} className="btn btn-danger" > Cancel </button> </center>
                  </OFMSUI.Row>
                </Form>
              </Modal.Body>
            </Modal>
            <Modal fade={false} size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={openAddPopUp} >
              <Modal.Header > <Modal.Title >Add Sub Heads</Modal.Title> </Modal.Header>
              <Modal.Body>
                <Form onSubmit={formik2.handleSubmit}>
                  <Table striped bordered hover id="my-table">
                    <thead className="fw-bold"> <tr> <th>Head ID</th><th>SubHead ID</th> <th>SubHead Name</th> </tr> </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="addheadid"
                            onChange={formik2.handleChange}
                            className={formik2.touched.addheadid && formik2.errors.addheadid ? "form-control is-invalid" : "form-control"}
                            disabled
                          ></Field>
                        </td>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="addsubheadid"
                            onChange={(e) => {
                              
                              const upper = e.target.value.toUpperCase();
                              formik2.setFieldValue("addsubheadid", upper)
                            }}
                            onKeyPress={(e) => AlphaNumericValidation(e)}

                            className={formik2.touched.addsubheadid && formik2.errors.addsubheadid ? "form-control is-invalid" : "form-control"}
                          ></Field>
                        </td>
                        <td style={{ width: "80px" }}>
                          <Field
                            type="text"
                            name="addsubheadname"
                            onChange={formik2.handleChange}
                            // onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                            className={formik2.touched.addsubheadname && formik2.errors.addsubheadname ? "form-control is-invalid" : "form-control"}
                          ></Field>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <OFMSUI.Row>
                    <center> <button type="button" style={{ marginRight: "1rem" }} size="sm" className="btn btn-success" onClick={() => { submitsubheadAddAction(); }} > Add </button> <button type="button" style={{ marginRight: "1rem" }} size="sm" onClick={() => { setopenAddPopUp(false); }} className="btn btn-danger" > Cancel </button> </center>
                  </OFMSUI.Row>
                </Form>
              </Modal.Body>
            </Modal>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
};

export default SubHeadMaster;
// import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import * as OFMSUI from "react-bootstrap";
// import React, { useState, useEffect } from "react";
// import HousingService from "../../../Services/HousingService";
// import { IoAddCircle, IoTrash } from "react-icons/io5";
// import { Button, Modal } from "react-bootstrap";
// import { FiEdit } from "react-icons/fi";
// import Swal from "sweetalert2";
// import { FaFastBackward } from "react-icons/fa";
// const SubHeadMaster = () => {
//   const history = useHistory();
//   const initialState = {
//     headid: "",
//     subheadid: "",
//     subheadname: "",
//     subheadseqid: "",
//   };
//   const [data, setData] = useState(initialState);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [subHeadsData, setSubHeadData] = useState([]);

//   const [subheadid, setSubheadId] = useState("");
//   const [subheadname, setSubheadName] = useState("");
//   const [popup, setPopup] = useState(false);
//   const [editpopup, seteditPopup] = useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const handleSave = () => {
//     const params = {
//       subheadid: subheadid,
//       subheadname: subheadname,
//       headid: data.headid,
//     };
//     HousingService.rowinsert(params).then((res) => {
//       if (res.data) {
//         setPopup(false);
//         showNotification("success", "Added successfully ");
//                 handleSubHeads(data.headid);
//       }
//     });
//   };
//   const handleCheckboxClick = (index) => {
//     if (selectedRows.includes(index)) {
//       setSelectedRows(selectedRows.filter((i) => i !== index));
//     } else {
//       setSelectedRows([...selectedRows, index]);
//     }
//   };
//   const handleDistChange = (e) => {
//     setData((prevData) => ({
//       ...prevData,
//       subheadname: e.target.value,
//     }));
//   };
//   const [distOptions, setDistOptions] = useState([]);
//   useEffect(() => {
//     HousingService.CGG_District().then((res) => {
//       if (res.data) {
//         setDistOptions(res.data);
//       }
//     });
//   }, []);
//   const handleHeadChange = (e) => {
//     setData((prevData) => ({
//       ...prevData,
//       headid: e.target.value,
//     }));
//   };
//   const [headOptions, setHeadOptions] = useState([]);
//   useEffect(() => {
//     HousingService.HeadNames().then((res) => {
//       setHeadOptions(res.data);
//     });
//   }, []);
//   const handleSubHeads = (headid) => {
//     const params = {
//       headid: headid,
//     };
//     HousingService.GetSubHeadsData(params).then((res) => {
//       if (res.data) {
//         setSubHeadData(res.data);
//         setIsSubmitted(true);
//       } else {
//       }
//     });
//   };
//   const openAddPopUp=()=>{
//     setPopup(true);
//   }
//   const showNotification = (type, message) => {
//     if (type === "success") {
//       Swal.fire("Success", message, "success");
//     } else if (type === "error") {
//       Swal.fire("Error", message, "error");
//     } else if (type === "warning") {
//       Swal.fire("Warning", message, "warning");
//     } else if (type === "info") {
//       Swal.fire("info", message, "info");
//     }
//   };

//   const handleDelete=()=>{
//     if (selectedRows.length > 0) {
//       const selectedRowsData = selectedRows.map((index) => subHeadsData[index]);
//       const requestBody = selectedRowsData.map((row) => ({

//         headid: row.headid,
//         subheadseqid:row.subheadseqid,
//       }));
//       Swal.fire({
//         text: "Are You Sure Want to Delete?",
//         icon: "question",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes",
//       }).then(async(result) => {
//         if (result.isConfirmed) {
//           const Update = await HousingService.rowdel(requestBody);
//           if (Update?.data?.SCODE === "01") {
//             showNotification("success", "Deleted successfully Headid");
//             setPopup(false);
//             handleSubHeads(data.headid);
//           }
//       }

//       })

//   }
//   else
//   {
//     showNotification("error", "Please Select CheckBox ");
//   }
//   }
//   const handleRowEdit = (subheadseqid, subheadid, subheadname) => {
//     if (selectedRows.length > 0) {
//     setSubheadId(subheadid);
//     setSubheadName(subheadname);
//     setData(prevData => ({
//       ...prevData,
//       subheadseqid: subheadseqid, // Update subheadseqid in the data state
//     }));
//     seteditPopup(true);

//   }
//   else{
//     showNotification("error", "Please Select CheckBox ");
//   }
//   };

//   const handleEditSave = () => {
//     const params = {
//       subheadid: subheadid,
//       subheadname: subheadname,
//       subheadseqid: data.subheadseqid,
//     };
//     HousingService.rowUpdate(params).then((res) => {
//       if (res.data) {
//         seteditPopup(false);
//         showNotification("success", "Updated successfully");
//         handleSubHeads(data.headid);
//       }
//     });
//   };

//   return (
//     <div>
//       <NavigationServicesHeader />

//       <OFMSUI.Container>
//               <OFMSUI.Row>
//                 <OFMSUI.Col
//                   xs={12}
//                   sm={12}
//                   md={12}
//                   lg={6}
//                   xl={6}
//                   xxl={6}
//                   className="page-titlespacing"
//                 >
//                   <div className="inner-herbpage-service-title1">
//                     <h1 style={{ marginLeft: "-15px" }}>
//                       SUBHEAD MASTER
//                     </h1>
//                   </div>
//                 </OFMSUI.Col>

//                 <OFMSUI.Col
//                   xs={12}
//                   sm={12}
//                   md={12}
//                   lg={6}
//                   xl={6}
//                   xxl={6}
//                   className="page-titlespacing"
//                 >
//                   <button
//               className="btn btn-primary btn-sm"
//               style={{ textAlign: "right", float: "right", marginTop: "30px",backgroundColor: "#603913",borderColor: "#603913", color: "#fff"
//               }}
//               type="reset"
//               onClick={() => history.goBack()}
//             >
//               <FaFastBackward /> &nbsp;Back
//             </button>

//                 </OFMSUI.Col>
//               </OFMSUI.Row>
//             </OFMSUI.Container>
//       <OFMSUI.Container className="outer-page-content-container ">
//         <OFMSUI.Row>
//         <OFMSUI.Col
//             xs={12}
//             sm={12}
//             md={12}
//             lg={3}
//             xl={3}
//             xxl={3}
//             className=""
//           >
//             </OFMSUI.Col>
//           <OFMSUI.Col
//             xs={12}
//             sm={12}
//             md={12}
//             lg={3}
//             xl={3}
//             xxl={3}
//             className=""
//           >
//             <label>
//               <b> District:</b>
//             </label>
//             <span className="mandatory" style={{ color: "red" }}>
//
//               *
//             </span>

//             <select
//               value={data.name}
//               onChange={handleDistChange}
//               className="form-control form-control-sm"
//             >
//               <option value="">--select--</option>
//               {distOptions.map((dist) => (
//                 <option key={dist.code} value={dist.name}>
//                   {dist.name}
//                 </option>
//               ))}
//             </select>
//           </OFMSUI.Col>
//           <OFMSUI.Col
//             xs={12}
//             sm={12}
//             md={12}
//             lg={3}
//             xl={3}
//             xxl={3}
//             className=""
//           >
//             <label>
//               <b> HeadNames:</b>
//             </label>
//             <span className="mandatory" style={{ color: "red" }}>
//
//               *
//             </span>

//             <select
//               value={data.headid}
//               onChange={handleHeadChange}
//               className="form-control form-control-sm"
//             >
//               <option value="">All</option>
//               {headOptions.map((head) => (
//                 <option key={head.headid} value={head.headid}>
//                   {head.heads}
//                 </option>
//               ))}
//             </select>
//           </OFMSUI.Col>
//           <OFMSUI.Col
//     xs={12}
//     sm={12}
//     md={12}
//     lg={1}
//     xl={1}
//     xxl={1}
//     className="m-3"
//   >
//     <button
//       type="button"
//       className="btn btn-primary btn-sm"
//       onClick={() => {
//         handleSubHeads(data.headid);
//       }}
//       style={{ alignItems: 'center',backgroundColor: "#603913",borderColor: "#603913", color: "#fff"}}
//     >
//       Submit
//     </button>
//   </OFMSUI.Col>
//         </OFMSUI.Row>

//         {isSubmitted && (
//           <OFMSUI.Table bordered>
//             <thead className="fw-bold">
//               <tr>
//                 <th>Sl No</th>
//                 <th>SubHead Id</th>
//                 <th>SubHead Name</th>
//                 <th>Check</th>
//                 <th>Edit</th>
//                 <th style={{ width: "9%" }}>
//
//                   <OFMSUI.Button
//                     className="btn btn-sm me-2"
//                     Title="Add"
//                     variant="success"
//                     color="success"
//                     style={{ marginleft: "200rem" }}
//                   >
//                     <IoAddCircle
//                       style={{ fontSize: "17px" }}
//                       onClick={openAddPopUp}
//                     />
//                   </OFMSUI.Button>
//                   <Button
//                     className="btn btn-sm me-2"
//                     Title="Delete"
//                     variant="danger"
//                     color="danger"
//                   >
//                     <IoTrash style={{ fontSize: "17px" }}   onClick={handleDelete}   />
//                   </Button>
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {subHeadsData.map((subheads, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>

//                   <td>{subheads.subheadid}</td>
//                   <td>{subheads.subheadname}</td>
//                   <td>
//                     <input
//                       type="checkbox"
//                       id={`myCheckbox_${subheads.subheadid}`}
//                       onClick={() => {
//                         handleCheckboxClick(index);
//                       }}
//                     />
//                   </td>

//                   <td>
//                     <Button
//                       className="btn btn-sm"
//                       Title="Edit"
//                       variant="warning"
//                       color="warning"
//                       onClick={(e) => {
//                         handleRowEdit(subheads.subheadseqid,subheads.subheadid,subheads.subheadname);
//                       }}

//                     >
//                       <FiEdit />
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </OFMSUI.Table>
//         )}
// {/* //ADD */}
//         <Modal
//           fade={false}
//           size="l"
//           aria-labelledby="contained-modal-title-vcenter"
//           centered
//           show={popup}
//         >
//           <Modal.Header>
//             <Modal.Title>SUBHEAD ADD</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <OFMSUI.Table>
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <label>
//                   <b>SubHeadId:</b>
//                 </label>
//                 <span
//                   className="mandatory"
//                   style={{ color: "red", marginLeft: "5px" }}
//                 >
//                   *
//                 </span>
//                 <input
//                   type="text"
//                   id="subheadid"
//                   onChange={(e) => setSubheadId(e.target.value)}
//                   style={{ width: "300px", marginLeft: "30px" }}
//                 />
//               </div>
//               <br></br>
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <label>
//                   <b>SubHeadName:</b>
//                 </label>
//                 <span
//                   className="mandatory"
//                   style={{ color: "red", marginLeft: "5px" }}
//                 >
//                   *
//                 </span>
//                 <input
//                   type="text"
//                   id="subheadname"
//                   onChange={(e) => setSubheadName(e.target.value)}
//                   style={{ width: "300px", marginLeft: "5px" }}
//                 />
//               </div>
//               <br></br>
//               <Button size="sm" type="submit" onClick={handleSave}>
//                 SAVE
//               </Button>
//               &nbsp;
//               <Button
//                 size="sm"
//                 variant="warning"
//                 onClick={() => setPopup(false)}
//               >
//                 Cancel
//               </Button>
//             </OFMSUI.Table>
//           </Modal.Body>
//         </Modal>
//         {add */}
//         <Modal
//           fade={false}
//           size="l"
//           aria-labelledby="contained-modal-title-vcenter"
//           centered
//           show={editpopup}
//         >
//           <Modal.Header>
//             <Modal.Title>SUBHEAD EDIT</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//   <OFMSUI.Table>
//     <div style={{ display: "flex", alignItems: "center" }}>
//       <label>
//         <b>SubHeadId:</b>
//       </label>
//       <span
//         className="mandatory"
//         style={{ color: "red", marginLeft: "5px" }}
//       >
//         *
//       </span>
//       <input
//         type="text"
//         id="subheadid"
//         value={subheadid}
//         onChange={(e) => setSubheadId(e.target.value)}
//         style={{ width: "300px", marginLeft: "30px" }}
//       />
//     </div>
//     <br />
//     <div style={{ display: "flex", alignItems: "center" }}>
//       <label>
//         <b>SubHeadName:</b>
//       </label>
//       <span
//         className="mandatory"
//         style={{ color: "red", marginLeft: "5px" }}
//       >
//         *
//       </span>
//       <input
//         type="text"
//         id="subheadname"
//         value={subheadname}      // Set value attribute using subheadname state
//         onChange={(e) => setSubheadName(e.target.value)}
//         style={{ width: "300px", marginLeft: "5px" }}
//       />
//     </div>
//     <br />
//     <Button size="sm" type="submit" onClick={handleEditSave}>
//       SAVE
//     </Button>
//     &nbsp;
//     <Button
//       size="sm"
//       variant="warning"
//       onClick={() => seteditPopup(false)}
//     >
//       Cancel
//     </Button>
//   </OFMSUI.Table>
// </Modal.Body>

//         </Modal>
//       </OFMSUI.Container>
//     </div>
//   );
// };

// export default SubHeadMaster;
